var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "sort",
    d: "M17.13,13.54c-0.12-0.13-0.29-0.2-0.47-0.2H7.34c-0.36,0-0.66,0.29-0.67,0.65c0,0.18,0.07,0.35,0.2,0.48  l4.66,4.66c0.25,0.26,0.66,0.27,0.92,0.02c0.01-0.01,0.01-0.01,0.02-0.02l4.66-4.66c0.26-0.25,0.28-0.65,0.03-0.91  C17.15,13.54,17.14,13.54,17.13,13.54z M17.13,9.54l-4.66-4.66c-0.25-0.26-0.66-0.27-0.92-0.02c-0.01,0.01-0.01,0.01-0.02,0.02  L6.87,9.54c-0.25,0.27-0.24,0.69,0.03,0.95c0.12,0.11,0.28,0.18,0.44,0.18h9.33c0.36,0,0.66-0.3,0.66-0.66  C17.32,9.83,17.25,9.66,17.13,9.54z",
    style: {
      fill: "rgb(119, 131, 161)"
    },
    vectorEffect: "non-scaling-stroke"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.72cc9bce.svg";
export { ForwardRef as ReactComponent };